import { withLabelsContext } from "context";
import React, { PureComponent } from "react";
import { Col, Row, Card } from "react-bootstrap";
import DataTable from "react-data-table-component";
import getTableStyles from "themes/table-styles";
import { Button, Loader, Select, Toolbar ,OverlayTooltip} from "components";
// import * as util from "services/util";
import DashboardPanel from "components/DashboardPanel/DashboardPanel";
import { IconRefresh , IconExport } from "Icons";
import HelpfulButton from 'components/Button/HelpfulButton';
// import "./ChapterStudentTable.css";
import css from "../ChapterProgress.css"
import { CSVLink } from "react-csv";
class ChapterStudentTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tableData: props.tableData && props.tableData || {},
      view: "chapter",
      selectedFilter: null,
    };
  }

  static propTypes = {};

  componentDidMount = () => {
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevProps.loaded !== this.props.loaded ||
      this.state.selectedFilter !== prevState.selectedFilter
    ) {
      // this.setState({ tableData: this.props.tableData })
      this.props.tableData && this.setDataFromProps();
    }
    if(this.props.type !== prevProps.type) {
      this.setState({selectedFilter: ""})
    }
  };

  setDataFromProps = () => {
    if (this.state.selectedFilter) {
      this.setState((s0) => ({
        tableData: {
          ...s0.tableData,
          contents:
          this.props.type === "T" ? this.props.tableData.contents?.filter(
            (row) => row.assessment? row.assessment[0].status === this.state.selectedFilter : this.state.selectedFilter
          ):
          this.props.type === "M" ? this.props.tableData.contents?.filter(
            (row) => row.modules? row.modules[0].module_status === this.state.selectedFilter : this.state.selectedFilter
          ):
            this.props.tableData.contents?.filter(
            (row) => row.status === this.state.selectedFilter
          ),
        },
      }));
    } else {
      this.setState({ tableData: this.props.tableData });
    }
  };

  // handelModuleChange = (newId) => {
  //   const newData = this.renderToolbar(newId);
  //   this.setState({
  //     selectedFilter: null,
  //     tableData: newData,
  //   });
  // };

  renderLoadingSpinner = () => (
    <Row>
      <Col md={12}>
        <div className="loading-indicator-wrapper">
          <div className="loading-indicator">
            <Loader active width={35} />
          </div>
        </div>
      </Col>
    </Row>
  );

  renderToolbar = () => {
    const addTip =
    this.props.ctx_labels.singular.clickToRefresh ;
    const options = 
      this.props.type === "T" ? [
      {label: this.props.ctx_labels.singular.yetToStart, value: 1},
      {label: this.props.ctx_labels.singular.inProgress, value: 2},
      {label: this.props.ctx_labels.singular.attended, value: 3},
      ]:
      this.props.type === "M" ? [
      {label: this.props.ctx_labels.singular.yetToStart, value: "Yet To Start"},
      {label: this.props.ctx_labels.singular.inProgress, value: "In progress"},
      {label: this.props.ctx_labels.singular.attended, value: "Completed"},
      ]:[
      { label:  this.props.ctx_labels.singular.attended, value: 3 },
      { label:  this.props.ctx_labels.singular.inProgress, value: 2 },
      { label:  this.props.ctx_labels.singular.yetToStart, value: 1 },
    ];

    let inOrder = [];

    inOrder = this.state.tableData.contents.map((s) => {
      const isStatus =
        this.props.type === "T" ?
        s.assessment?.map((ass)=> {
          return( 
          ass.status === 2 ? "Attended" : 
        ass.status === 1 ? "In progress" : 
        "Yet To Start"
        )})
         :
          this.props.type === "M" ?
          s.modules?.map((mod) => {
           return(
             mod.module_status === "Completed" ? "Attended" :
             mod.module_status === "In progress" ? "In progress" :
             "Yet To Start"
           )})
            :
        s.status === 1 ?
          "Yet to Start" :
        s.status === 2 ?
            "In Progress" :
                "Attended"
      return( 
        this.props.type === "T" ?
        [s.student_name, isStatus, s.scorePercentage, s.totMarks, s.evaluatedBy,s.totPoints]
        : 
        this.props.type === "M" ?
        [s.student_name, isStatus, s.progressPerc, s.minPageView, s.correctAns, s.pleCredit,s.contentLength]
        : 
        [s.registration_no, s.student_name,
        isStatus, s.progress_percent, s.minutes_viewed, s.pages_viewed, s.ple_score]
        // this.props.type === 'T' ? s.assessment[0].score_percentage : s.progress_percent : this.props.type === 'T' ? s.assessment[0].evaluated_by,  
      // s.assessment[0].tot_obt_marks]
      )
      });

    const handleFilterChange = (value) => {
      this.setState({
        selectedFilter: value,
      });
    };

    const types = this.props.type === 'T' ? 
     this.props.testId : 
    this.props.type === 'M' ? 
     this.props.moduleId  : this.props.chapterId

    return (
      <Toolbar>
        <Row>
          <Col>
            <Toolbar.Item>
              <Select
                // style={{ width: '80%', marginLeft: "10px" }}
                options={options}
                placeholder={`Filter`}
                value={this.state.selectedFilter}
                onChange={handleFilterChange}
              />
            </Toolbar.Item>
          </Col>
          <Col className="progress-table-refresh">
            <Toolbar.Item>
              <HelpfulButton
                // className = "refreshIcon"
                variant="link"
                tip={addTip}
                iconOnly
                onClick={() => this.props.onRefresh(types, this.props.type)}
              >
                <IconRefresh />
              </HelpfulButton>
            </Toolbar.Item>
          </Col>
          <Col className="progress-table-download">
            <Toolbar.Item>
              <OverlayTooltip
                placement="top"
                tip="Download CSV"
              >
                <CSVLink
                  headers={this.getCSVheaders()}
                  filename={`${this.props.coursepub_name}_StudentProgress.csv`}
                  data={inOrder}
                >
                  <Button
                    variant="link"
                  // className="p-0"
                  >
                    <IconExport />
                  </Button>
                </CSVLink>
              </OverlayTooltip>
            </Toolbar.Item>
          </Col>
        </Row>
      </Toolbar>
    );
  };

  getCSVheaders = () => {
   return this.state.tableData.headers.map((s)=>{
    if(s.selector==="link"){
      return null;
    }
     return [s.name]
   })
  }

  renderChapterStudentTable = () => {
    const { theme } = this.props;
    const { tableData } = this.state;
    const tableStyles = getTableStyles(theme);

    let downloadCsv = true;
    if(!tableData || 
      (Array.isArray(tableData) && tableData.length) || 
      typeof tableData === 'object' &&  
      Object.keys(tableData).length === 0)
    {
      downloadCsv=false
    }

      return downloadCsv ? (
      <DashboardPanel
        title={`${this.props.ctx_labels.plural.trainee} Progress`}
        fullScreen
        sideContent={this.renderToolbar()}
      >
        <Card className="pb-25 border-0">
          <DataTable
            noHeader={true}
            columns={tableData.headers}
            data={tableData.contents}
            customStyles={tableStyles}
            pagination
            striped
           // overflowY={true}
            // overflowYOffset="400px"
            // style={{ overflow: "scroll" }}
            className=""
          />
        </Card>
      </DashboardPanel>
    ) : (
      // <ReactTable
      //   className="-striped- -highlight"
      //   getTrProps={(state, rowInfo) => {
      //     const index = rowInfo ? rowInfo.index : -1;
      //     if (index >= 0) {
      //       return {
      //         //onClick: () => this.props.onRowClick(rowInfo.row),
      //       };
      //     } else {
      //       return {};
      //     }
      //   }}
      //   data={tableData.contents}
      //   columns={tableData.headers}
      //   showPagination={true}
      //   defaultPageSize={defaultPage || 5}
      //   // showPaginationBottom= {true}
      //   showPaginationTop={false}
      //   showPageSizeOptions={false}
      //   showPageJump={false}
      //   noDataText={`No ${view}s found`}
      //   defaultSorted={[
      //     {
      //       id: "status",
      //       desc: false,
      //     },
      //   ]}
      // />
      this.renderLoadingSpinner()
     );
  };

  render = () => {
    const { chapterId, expandView, open  } = this.props;
    return this.renderChapterStudentTable();
  };
}

export default withLabelsContext(ChapterStudentTable);
